import { render } from "./GameUpdates.vue?vue&type=template&id=65e8afff&scoped=true"
import script from "./GameUpdates.vue?vue&type=script&lang=js"
export * from "./GameUpdates.vue?vue&type=script&lang=js"

import "./GameUpdates.vue?vue&type=style&index=0&id=65e8afff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e8afff"]])

export default __exports__